export const RETRYABLE_STATUS_CODES: ReadonlyArray<number> = [500, 502, 503];

export const getErrorStatusCode = (error: unknown): number | undefined => {
	if (error != null && typeof error === 'object' && 'statusCode' in error) {
		const { statusCode } = error;
		if (typeof statusCode === 'number') {
			return statusCode;
		}
	}
	return undefined;
};

const isNetworkError = (error: unknown): boolean =>
	error instanceof TypeError || (error instanceof Error && error.cause instanceof TypeError);

export const isRetryableCmdbError = (error: unknown): boolean => {
	const statusCode = getErrorStatusCode(error);
	if (statusCode !== undefined) {
		return RETRYABLE_STATUS_CODES.includes(statusCode);
	}
	return isNetworkError(error);
};
